
import { Component, Prop, Vue } from 'vue-property-decorator'
import Icon from '~/components/common/icon/Icon.vue'

@Component({
  components: {
    Icon
  }
})
export default class VideoPlayer extends Vue {
  @Prop({ type: String, required: true }) readonly src: string
  @Prop({ type: String }) readonly videoClass: string

  $refs: {
    videoPlayer: HTMLVideoElement
  }

  isPlaying = false

  togglePlay() {
    const video = this.$refs.videoPlayer
    if (video.paused) {
      video.play()
    } else {
      video.pause()
    }
  }

  onPlay() {
    this.isPlaying = true
    this.$emit('start', this.$refs.videoPlayer.currentTime)
  }

  onPause() {
    this.isPlaying = false
    this.$emit('stop', this.$refs.videoPlayer.currentTime)
  }
}
